// src/screens/legal/PrivacyPolicy.jsx

import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h1>Məxfilik Siyasəti</h1>
        <p><strong>Yenilənib:</strong> 18 May 2025</p>

        <p>
          MotoTaksi.az olaraq istifadəçilərimizin şəxsi məlumatlarının məxfiliyini qorumağa sadiqik.
          Bu Məxfilik Siyasəti, bizim mobil tətbiqimiz və veb platformamız vasitəsilə toplanan məlumatların
          necə istifadə olunduğunu və qorunduğunu izah edir.
        </p>

        <h2>1. Toplanan Məlumatlar</h2>
        <ul>
          <li>Ad, soyad və əlaqə məlumatları (telefon nömrəsi, e-poçt)</li>
          <li>Yer məlumatları (GPS), əgər istifadəçi icazə veribsə</li>
          <li>Tətbiqdaxili əməliyyat və istifadə məlumatları</li>
          <li>Ödəniş və faktura məlumatları (yalnız Epoint sistemində saxlanılır)</li>
        </ul>

        <h2>2. Məlumatların İstifadəsi</h2>
        <p>Toplanan məlumatlar aşağıdakı məqsədlərlə istifadə olunur:</p>
        <ul>
          <li>Xidmətin göstərilməsi və sifarişlərin yerinə yetirilməsi</li>
          <li>Ödənişlərin icrası və təhlükəsizlik yoxlamaları</li>
          <li>Tətbiqin funksionallığının təkmilləşdirilməsi</li>
          <li>Texniki dəstək və istifadəçi sorğularının cavablandırılması</li>
        </ul>

        <h2>3. Məlumatların Tərəfdaşlarla Paylaşılması</h2>
        <p>Şəxsi məlumatlar yalnız aşağıdakı hallarda paylaşılır:</p>
        <ul>
          <li>Ödəniş operatorları ilə (Epoint.az və s.)</li>
          <li>Qanuni sorğular zamanı hüquq-mühafizə orqanları ilə</li>
          <li>Tətbiqin işləməsi üçün xidmət göstərən texniki tərəfdaşlarla</li>
        </ul>

        <h2>4. Məlumatların Saxlanması</h2>
        <p>
          Toplanan məlumatlar müvafiq qanunvericilik tələblərinə uyğun olaraq saxlanılır
          və yalnız zəruri müddət ərzində qorunur.
        </p>

        <h2>5. İstifadəçi Hüquqları</h2>
        <p>İstifadəçilər aşağıdakı hüquqlara malikdir:</p>
        <ul>
          <li>Məlumatlarının silinməsi və ya düzəldilməsi tələbi</li>
          <li>Məlumatların istifadəsinə məhdudiyyət qoyulması</li>
          <li>Öz məlumatlarının surətini tələb etmək</li>
        </ul>

        <h2>6. Əlaqə</h2>
        <p>
          Məxfilik siyasəti ilə bağlı suallar üçün bizimlə <a href="mailto:support@mototaksi.az">support@mototaksi.az</a> elektron poçt ünvanı vasitəsilə əlaqə saxlaya bilərsiniz.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
